import Glyph from './Glyph';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.border}>
        <div className={styles.content}>
          <div className={styles.left}>
            <Glyph className={styles.glyph} />
            <span className={styles.name}>CMPND.DEV</span>
          </div>
          <div className={styles.right}>
            <span className={styles.copy}>
              &copy; {new Date().getFullYear()} CMPND.DEV
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
